import { render, staticRenderFns } from "./SegmentSection.vue?vue&type=template&id=458c4478&scoped=true"
import script from "./SegmentSection.vue?vue&type=script&lang=js"
export * from "./SegmentSection.vue?vue&type=script&lang=js"
import style0 from "./SegmentSection.vue?vue&type=style&index=0&id=458c4478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c4478",
  null
  
)

export default component.exports